import { ImageElement } from "@redotech/redo-content-builder-common/element-schema";
import ImageIcon from "@redotech/redo-icons/image-plus.svg";
import { Flex } from "@redotech/redo-web/flex";
import { memo } from "react";
import { getBaseElementStyles } from "./base-element-styles";
import * as ImageCSS from "./form-image.module.css";

export const FormImage = memo(function FormImage({
  element,
}: {
  element: Omit<ImageElement, "type"> & { type: string };
}) {
  const hasImage = element.url !== "";
  const baseStyles = getBaseElementStyles(element);
  // Each axis is native unless its toggle is explicitly off and a non-zero
  // size is set. Native means the container decides the width and the image
  // keeps its intrinsic height; an explicit size instead pins the box, which
  // is what stops an oversized upload from pushing the rest of the form out
  // of the viewport.
  const widthPx =
    element.useNativeWidth === false ? element.widthPx : undefined;
  const heightPx =
    element.useNativeHeight === false ? element.heightPx : undefined;

  return (
    <Flex
      height="full"
      style={{
        ...baseStyles,
        ...(widthPx ? { width: `${widthPx}px`, maxWidth: "100%" } : {}),
        ...(heightPx ? { height: `${heightPx}px` } : {}),
      }}
      w="full"
    >
      {hasImage ? (
        <img
          // Empty string signals a decorative image to screen readers (WCAG)
          alt={element.altText ?? ""}
          src={element.url}
          style={{
            width: "100%",
            height: "100%",
            objectFit: element.objectFit ?? "cover",
            ...(element.cornerRadius !== undefined && {
              borderRadius: `${element.cornerRadius}px`,
            }),
          }}
        />
      ) : (
        <div className={ImageCSS.placeholder}>
          <ImageIcon />
          Add image
        </div>
      )}
    </Flex>
  );
});
